module.exports = __webpack_public_path__ + "img/vip_recharge.4098e406.png";